import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  totalCount: 0,
  entities: [],
};

export const newCategorySlice = createSlice({
  name: "newCategory",
  initialState: initialWorkersState,
  reducers: {
    categoryList: (state, action) => {
      const { category } = action.payload;

      state.entities = category;
      state.totalCount = category.length;
    },
  },
});
